import Vue from 'vue'
import App from './App.vue'

import store from './store'
import router from './router'
import firebase from './firebase'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
    vuetify,
    store: store,
    router: router,
    firebase: firebase,
    render: h => h(App)
}).$mount('#app');
